@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.FlashMessage {
  display: flex;
  column-gap: 2px;
}
